import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import { PaginationTypes } from 'types/sharedResponse'
import { handleResponseErr } from 'utils/apiHelperUtils'
import { Job } from '../actions'
import * as actions from './actions'
import { OpenJob } from './actions'

export type actionType = 'updateJob' | 'createJob' | ''

type InitialStateType = {
  pagination: PaginationTypes
  jobs: Job[]
  open_jobs: number
  openJobsList: OpenJob[]
  skip_onboarding?: boolean
  action: actionType
  activeJobs?: Job[]
  fetching: boolean
  success: boolean
}

const initialState: InitialStateType = {
  jobs: [],
  open_jobs: 0,
  openJobsList: [],
  skip_onboarding: true,
  activeJobs: [],
  action: '',
  success: false,
  pagination: {
    current_page: 1,
    next_page: 2,
    page: 1,
    per_page: 10,
    total_entries: 10,
    total_pages: 2,
  },
  fetching: false,
}

export default function reducer(state = initialState, action: Action): InitialStateType {
  switch (action.type) {
    case actions.DELETE_JOB_BY_ID_PENDING:
    case actions.CREATE_JOB_PENDING:
    case actions.GET_ALL_JOBS_PENDING:
    case actions.GET_JOB_BY_ID_PENDING:
    case actions.GET_JOB_TEMPLATE_PENDING:
    case actions.GET_OPEN_JOBS_PENDING:
    case actions.UPDATE_JOB_PENDING: {
      return {
        ...state,
        fetching: true,
        action: '',
      }
    }

    case actions.CREATE_JOB_FULFILLED:
    case actions.DELETE_JOB_BY_ID_FULFILLED:
    case actions.UPDATE_JOB_FULFILLED: {
      const message = action?.payload?.data?.data.message
      Toastr.success(message)
      return {
        ...state,
        success: true,
        action:
          // eslint-disable-next-line no-nested-ternary
          action.type === 'UPDATE_JOB_FULFILLED'
            ? 'updateJob'
            : action.type === 'CREATE_JOB_FULFILLED'
            ? 'createJob'
            : '',
        fetching: false,
      }
    }

    case actions.GET_ALL_JOBS_FULFILLED: {
      return {
        ...state,
        ...action?.payload?.data?.data,
        pagination: action?.payload?.data.pagination,
        fetching: false,
        success: true,
        action: '',
      }
    }

    case actions.GET_JOB_TEMPLATE_FULFILLED: {
      return {
        ...state,
        activeJobs: action?.payload?.data?.data ?? [],
        fetching: false,
        success: true,
        action: '',
      }
    }

    case actions.GET_JOB_BY_ID_FULFILLED: {
      return {
        ...state,
        jobs: [action.payload?.data.data],
        action: '',
        fetching: false,
        success: true,
      }
    }

    case actions.GET_OPEN_JOBS_FULFILLED: {
      return {
        ...state,
        openJobsList: action.payload.data.data,
        fetching: false,
        success: true,
      }
    }

    case actions.DELETE_JOB_BY_ID_REJECTED:
    case actions.GET_JOB_BY_ID_REJECTED:
    case actions.UPDATE_JOB_REJECTED:
    case actions.GET_JOB_TEMPLATE_REJECTED:
    case actions.GET_ALL_JOBS_REJECTED:
    case actions.GET_OPEN_JOBS_REJECTED:
    case actions.CREATE_JOB_REJECTED: {
      Toastr.error(handleResponseErr({ response: action.payload }))
      return {
        ...state,
        success: false,
        fetching: false,
      }
    }

    default:
      return state
  }
}
